export enum ACTIVE_STATUS_ENUM {
  Activo = 'Activo',
  Arrendado = 'Arrendado',
  Baja = 'Baja'
}

export enum ACTIVE_STATUS_COLOR_ENUM {
  Activo = 'success',
  Arrendado = 'warning',
  Baja = 'danger'
}
